import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    token: null,
    user: null,
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setToken: (state, action) => {
            state.token = action.payload;
        },
        setUser: (state, action) => {
            state.user = action.payload;
        },
        logoutUser: state => {
            state.token = null;
            state.user = null;
        },
    },
});

export const { setToken, setUser, logoutUser } = authSlice.actions;

export default authSlice.reducer;
